module.exports = __webpack_public_path__ + "img/medal.c453040c.svg";